'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = featured;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _caligramReact = require('caligram-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function featured(event) {
  var date = (0, _moment2.default)(event.start_date);
  var query = {
    date: (0, _moment2.default)(event.next_date).format('YYYY-MM-DD_HH-mm-ss')
  };
  var itemAttributes = { className: 'EventListItem grid' };
  if (event.display_image_url) {
    itemAttributes.style = { backgroundImage: 'url(' + event.photo_url + ')' };
  }

  var dateFormat = function dateFormat(ev) {
    if ((0, _moment2.default)(ev.start_date).format('Do MMMM') === (0, _moment2.default)(ev.end_date).format('Do MMMM') || !ev.end_date) {
      return _react2.default.createElement(
        'span',
        null,
        (0, _moment2.default)(ev.start_date).format('Do MMMM HH[h]mm')
      );
    }

    return _react2.default.createElement(
      'span',
      null,
      (0, _moment2.default)(ev.start_date).format('Do MMMM'),
      ' au ',
      (0, _moment2.default)(ev.end_date).format('Do MMMM')
    );
  };

  return _react2.default.createElement(
    'article',
    itemAttributes,
    _react2.default.createElement(
      _reactRouter.Link,
      { to: { pathname: '/evenements/' + event.slug + '/' + event.id, query: query } },
      event.types && _react2.default.createElement(_caligramReact.SelectionList, { appearance: 'tag', available: event.types, layout: 'inline', labelKey: 'name' }),
      _react2.default.createElement(
        'div',
        { className: 'info' },
        _react2.default.createElement(
          'h1',
          null,
          event.title
        ),
        _react2.default.createElement(
          'time',
          { dateTime: date.format('YYYY-MM-DDTHH:mm') },
          dateFormat(event)
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/templates/featured.js
// module id = 1151
// module chunks = 0